import { render, staticRenderFns } from "./DiscldgDialog.vue?vue&type=template&id=67d1e1fa&"
import script from "./DiscldgDialog.vue?vue&type=script&lang=js&"
export * from "./DiscldgDialog.vue?vue&type=script&lang=js&"
import style0 from "./DiscldgDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DiscldgDialog.vue"
export default component.exports